export default [
  // ================ jubelio (P26_0039) ================
  // Route name = module alias `jubelio_index`, registered by migration
  // 2026_10_06_120000_insert_jubelio_monitor_modules.
  {
    name: "jubelio_index",
    path: "/jubelio",
    component: () => import("../pages/jubelio/index.vue"),
  },
];
